import {Component, OnInit} from '@angular/core';
import { CookieManagerService } from 'src/app/shared/Services/cookie.service';

@Component({
  selector: 'app-manage-token',
  templateUrl: './manage-token.component.html',
  styleUrls: ['./manage-token.component.scss']
})
export class ManageTokenComponent implements OnInit {

  constructor(private cookieManager: CookieManagerService) {
  }

  ngOnInit() {
    this.cookieManager.setCookie('exactStatus', 'true');
  }

  closePage() {
    window.parent.postMessage('message', location.origin);
    window.close();
  }
}
